import { render } from "./assets-list.vue?vue&type=template&id=6d9757a5"
import script from "./assets-list.vue?vue&type=script&lang=js"
export * from "./assets-list.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__